// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Workorder.yaml
// Generated: 2026-10-19T08:02:17.775Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateWorkorder, UpdateWorkorder, Workorder } from '@/types/forestry/Workorder';

/**
 * Workorder Service
 * CRUD operations for Workorder via the ABP API.
 */
export const workorderService = new EntityService<Workorder, CreateWorkorder, UpdateWorkorder>(
  '/api/forestry/workorder',
  'Workorder',
);
